import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { useCoachCategoryFormSidebar } from "@modules/coachCategories/hooks/useCoachCategoryFormSidebar"
import { word } from "@modules/core/utils/i18n"
import { PlusIcon } from "lucide-react"

export function CoachPlanningPage() {
  const { navigateToCoachCategoryCreation } = useCoachCategoryFormSidebar()

  return (
    <div className="relative min-h-full w-full bg-surface-background-default p-6">
      <div className="flex flex-col gap-4">
        <Text fontStyle="HL" className="font-semibold text-textOnSurface-default">
          {word("menu.planning")}
        </Text>
        <div className="flex w-full justify-end gap-2">
          <div className="flex items-center rounded-full bg-surface-background-secondary px-3 py-2.5">
            <Button variant="secondarySecondary" size="md" onClick={navigateToCoachCategoryCreation}>
              <PlusIcon />
              <Text fontStyle="LM">{word("coach.planning.category.form.add.title")}</Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
